import Vue from 'vue';
import VueRouter from 'vue-router';
import { vxm } from '@/store';

import login from '@/views/login.vue';
import machine_list from '@/views/machine_list.vue';
import pmap from '@/views/pmap.vue';
import user_list from '@/views/user_list.vue';
import user_edit from '@/views/user_edit.vue';
import group_list from '@/views/group_list.vue';
// import group_edit from '@/views/group_edit.vue';
import event_list from '@/views/event_list.vue';
import battery_chart from '@/views/battery_chart.vue';
import corp_list from '@/views/corp_list.vue';

Vue.use(VueRouter);

const routes = [
    {
        path: '/',
        name: '/',
        component: login,
        meta: { isPublic: true },
    },
    {
        path: '/machine_list',
        name: 'machine_list',
        component: machine_list,
        meta: { isPublic: true },
    },
    {
        path: '/login',
        name: 'login',
        component: login,
        meta: { isPublic: true },
    },
    {
        path: '/pmap',
        name: 'pmap',
        component: pmap,
        meta: { isPublic: false },
    },
    {
        path: '/user_list',
        name: 'user_list',
        component: user_list,
        meta: { isPublic: false },
    },
    {
        path: '/user_edit',
        name: 'user_edit',
        component: user_edit,
        meta: { isPublic: false },
    },
    {
        path: '/group_list',
        name: 'group_list',
        component: group_list,
        meta: { isPublic: false },
    },
    // {
    //     path: '/group_edit',
    //     name: 'group_edit',
    //     component: group_edit,
    //     meta: { isPublic: false },
    // },
    {
        path: '/event_list',
        name: 'event_list',
        component: event_list,
        meta: { isPublic: false },
    },
    {
        path: '/battery_chart',
        name: 'battery_chart',
        component: battery_chart,
        meta: { isPublic: false },
    },
    {
        path: '/corp_list',
        name: 'corp_list',
        component: corp_list,
        meta: { isPublic: false },
    },
];

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes,
});

router.beforeEach((to, from, next) => {
    if (to.matched.some(page => page.meta.isPublic) || vxm.user.token) {
        next();
    } else {
        next('/login');
    }
});

export default router;
